import { Zoom } from '@mui/material';
import { Spinner } from 'flowbite-react';
import { get } from 'lodash';
import React from 'react';
import { useMutation } from 'react-query';
import { generateMeetingLink } from 'src/apis/application';
import { useToast } from 'src/context/ToastProvider';

const GenerateMeetingLinkButton = ({
	onGenerate,
	positionId,
	campusApplicationId,
}: {
	onGenerate: (meetingLink: string) => void;
	positionId?: string;
	campusApplicationId?: string;
}) => {
	const toast = useToast();
	const generateMeetingLinkFn = useMutation(['generateMeetingLink'], generateMeetingLink, {
		onSuccess(data) {
			onGenerate && onGenerate(data?.meetingLink);
			toast({
				title: 'Meeting link generated successfully',
				type: 'success',
			});
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: `Error occured while generating meeting link ${errorMessage}`,
				type: 'error',
			});
		},
	});
	return (
		<>
			<button
				className="underline text-sm text-[#7777E7] hover:text-blue-600 active:text-blue-800 disabled:text-gray-600"
				disabled={generateMeetingLinkFn.isLoading}
				onClick={() => {
					generateMeetingLinkFn.mutate({
						positionId: positionId || '',
						campusApplicationId: campusApplicationId || '',
					});
				}}
			>
				Generate Meeting Link
			</button>
			<div className="inline-flex ml-1">
				<Zoom in={generateMeetingLinkFn?.isLoading} unmountOnExit>
					<div>
						<Spinner size="sm" />
					</div>
				</Zoom>
			</div>
		</>
	);
};

export default GenerateMeetingLinkButton;
